import { useAtomValue } from "jotai";

import { H1, H3 } from "@sorcery/ui";

import { deckJotai } from "~/state/deckJotai";

export const PreconHeader = () => {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const precon = useAtomValue(deckJotai)!;

  return (
    <div className="mb-4">
      <div className="mb-2 flex flex-col justify-center text-big-text-color">
        <H1 className="!mb-0 line-clamp-2 pt-2 !text-2xl sm:!text-3xl md:!text-4xl lg:!text-5xl 2xl:!text-7xl">
          {precon.name}
        </H1>
        <H3 className="!mb-0 transition-all">Official Sorcery TCG Preconstructed Decklist</H3>
      </div>
    </div>
  );
};
